import React from 'react';
import {
  isLifelineMode,
  isPlayGroundMode,
} from '../../../../utils/CookieToken';
import { playGroundModeEvent } from '../../../../analytics/events';
import getStore from '../../../../store/store';
import { MetricsForJumboEvent } from '../../../../analytics/constants';

const PlaygroundMode = () => {
  const store = getStore(History);
  const state = store.getState();
  const { ordersState = {} } = state;

  const handlePlayGroundMode = (e) => {
    const isPlayGroundMode = JSON.parse(
      sessionStorage.getItem('playGroundMode'),
    );
    if (isPlayGroundMode) sessionStorage.removeItem('playGroundMode');
    else sessionStorage.setItem('playGroundMode', JSON.stringify(true));

    playGroundModeEvent({
      [MetricsForJumboEvent.customer_id]: ordersState?.customer_id,
    });

    const playGroundSwitchTimer = setTimeout(() => {
      window.location.reload();
      clearTimeout(playGroundSwitchTimer);
    }, 300);
  };

  return (
    <div
      className={`tw-py-1 tw-flex tw-w-full tw-items-center tw-justify-between tw-border-solid tw-border-grey-200 tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-pb-3 tw-font-medium tw-text-grey-700 ${
        isLifelineMode ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'
      }`}
    >
      Playground Mode
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <label
        className={` switch ${
          isLifelineMode ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'
        }`}
      >
        <input
          type='checkbox'
          onChange={(e) => {
            handlePlayGroundMode(e);
          }}
          defaultChecked={isPlayGroundMode}
          disabled={!isLifelineMode}
        />
        <span className='slider round'></span>
      </label>
    </div>
  );
};

export default PlaygroundMode;
